









import Header from "@/component/header.vue"
import Footer from "@/component/footer.vue"
import axios from 'axios';
import {Env} from "@/env";

export default {
    name: "app",
    components: {
        Header,
        Footer,
    }
};

axios.defaults.withCredentials = true;
axios.defaults.headers.common['Access-Control-Allow-Origin'] = 'http://localhost:8080';
axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';
axios.interceptors.request.use(request => {
    if (!(Env.isDev())) {
        let userCredentials = btoa(Env.getBasicId() + ":" + Env.getBasicPass());
        request.headers = {
            'Authorization': 'Basic ' + userCredentials
        };
    } else {
        request.baseURL = Env.getBaseUrl();
    }
    // セッションストレージからCSRFトークンを取得してリクエストヘッダに設定
    const csrf = sessionStorage.getItem("csrfToken");
    console.info("Request  csrf --> " + csrf)

    if (csrf) request.headers["X-CSRF-TOKEN"] = csrf;

    return request;
});

/**
 * レスポンスヘッダからCSRFトークンを取得してセッションストレージに保存します。
 * @param response HTTPレスポンス
 */
let setCsrfTokenToSession = (response): void => {
    if (response) {
      const csrf = response.headers["x-csrf-token"]; // axiosで読み込むとヘッダは小文字になる
      console.info("Response csrf <-- " + csrf)
      if (csrf) sessionStorage.setItem("csrfToken", csrf);
    }
};

axios.interceptors.response.use(response => {
    setCsrfTokenToSession(response);
    return response;
}, error => {
    setCsrfTokenToSession(error.response);
    return Promise.reject(error);
});

